<template>
  <svg
    :class="['svg-icon', isSpinning && 'svg-icon--spin']"
    v-bind="restAttrs"
    :style="styleVars"
    :role="title ? 'img' : undefined"
    :aria-hidden="title ? undefined : 'true'"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup lang="ts">
import { computed, useAttrs, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    name: string // 必填，svg sprite 的 id
    size?: number | string // 同时作为宽/高；支持 '1.5em'
    width?: number | string // 单独宽
    height?: number | string // 单独高
    color?: string // 同时作用于 fill & stroke
    fill?: string // 只控制 fill
    stroke?: string // 只控制 stroke
    spin?: boolean // 是否旋转动画
    title?: string // a11y 标题
  }>(),
  {
    name: '',
    prefix: '',
    size: '16px',
    spin: false,
  },
)

const symbolId = computed(() =>
  props.name.startsWith('icon-') ? `#${props.name}` : `#icon-${props.name}`,
)

const $attrs = useAttrs()
const restAttrs = computed(() => {
  const { class: _c, style: _s, ...rest } = $attrs

  return { ...rest, fill: props.fill ?? props.color, stroke: props.stroke ?? props.color }
})

const styleVars = computed(() => {
  const svgWidth = props.width ?? props.size
  const svgHeight = props.height ?? props.size

  return {
    width: svgWidth + (svgWidth.toString().includes('px') ? '' : 'px'),
    height: svgHeight + (svgHeight.toString().includes('px') ? '' : 'px'),
  }
})

const isSpinning = ref(props.spin)
watch(
  () => props.spin,
  (newVal) => {
    if (newVal) {
      isSpinning.value = true
    } else {
      setTimeout(() => {
        isSpinning.value = false
      }, 600)
    }
  },
)
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  stroke-linejoin: round;
  transition:
    fill 0.3s ease,
    stroke 0.3s ease; /* 平滑过渡 */
}
.svg-icon--spin {
  animation: svg-spin 0.6s linear 1;
}

svg:focus,
svg:active {
  outline: none;
}
@keyframes svg-spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
